import type { NameAndType } from '../../types.js'
import { assignCommonProperties } from '../../util/data/assign-common-properties.js'

import { Parameter } from '../../script/parameter.js'

export class RestrictableItem {
	itemName?: string
	parameters: Parameter[] = []
	generics: string[] = []
	contextDeclarations: NameAndType[] = []
	contextImports: Record<string, string> = {} // key: named import, value: module specifier
	functionName?: string
	defaultCode?: string

	constructor(init?: Partial<RestrictableItem>) {
		assignCommonProperties(this, init)
	}
}
